import { todayTime, GetPreMonthDay, GetNextMonthDay, getFormatDate } from '../../../times/moment'
export default {
	methods: {
		// 获取上面的生产区域信息
		getOrgids(isFen = false) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: '',
				type: '3',
			}
			if (isFen) {
				params.parentOrgId = this.allOrgId
			} else {
				params.parentOrgId = userInfos.orgId
			}
			console.log(params)
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						if (datas && datas.length) {
							this.$set(this.orgForm, 'orgId', datas[0]['orgId'])
							// 获取视频监控下拉选数据
							this.getVideoSelect()
							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取环境监测下拉选数据
								this.getEnverSelect()
								// 获取设备操作列表
								this.getEquipList()
							}, 100)
							this.equipTime = setInterval(() => {
								// 获取设备操作列表
								this.getEquipList()
							}, 1000)
						} else {
							this.loading = false
							this.$set(this.orgForm, 'orgId', '')
							this.codeSelect = []
							// 传感器恢复默认值
							this.codeIsWarn = false
							this.$set(this.codeForm, 'deviceId', '')
							// 设备操作恢复默认值
							this.equipList = {}
							this.equipListSd = []
							this.equipListSsd = []
							// 视频监控回复默认值
							this.isShowVideo = false
							this.$set(this.videoForm, 'id', '')
							this.videoSelect = []
						}
					} else {
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.loading = false
				})
		},
		// 获取网点/大棚数据
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			// 1 分公司 2 网点 3 生产区域
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.loading = false
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			if (this.equipTime) {
				clearInterval(this.equipTime)
				this.equipTime = null
			}
			this.allOrgId = val
			console.log(val)
			this.getOrgids(true)
		},
		// 大鹏/区域的选择
		changeOrg() {
			// 获取环境监测下拉选数据
			this.getEnverSelect()
			// 获取视频监控下拉选数据
			this.getVideoSelect()
			if (this.equipTime) {
				clearInterval(this.equipTime)
				this.equipTime = null
			}
			// 获取设备操作列表
			this.getEquipList()

			this.equipTime = setInterval(() => {
				// 获取设备操作列表
				this.getEquipList()
			}, 1000)
		},
		// 获取环境监测下拉选数据
		getEnverSelect() {
			this.$http
				.getAction(this.$api.findDeviceByOrgId, this.orgForm)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || []
						this.codeSelect = datas || []
						this.codeIsWarn = false
						if (datas && datas.length) {
							this.$set(this.codeForm, 'deviceId', datas[0]['id'])
							this.$nextTick(() => {
								this.codeChangeHandel(datas[0]['id'])
							})
						} else {
							this.$set(this.codeForm, 'deviceId', '')
							this.isLine = false
						}
					} else {
						this.codeIsWarn = false
						this.codeSelect = []
						this.isLine = false
					}
				})
				.catch(() => {
					this.codeIsWarn = false
					this.codeSelect = []
					this.isLine = false
				})
		},
		// 获取视频监控下拉选数据
		getVideoSelect() {
			this.$http
				.getAction(this.$api.findVideoByOrgId, this.orgForm)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || []
						this.videoSelect = datas || []
						if (datas && datas.length) {
							this.isShowVideo = true
							this.$set(this.videoForm, 'id', datas[0]['id'])
							if (datas[0]['vurl'] && datas[0]['vurl'] != '') {
								this.isVideoEmpty = false
								this.$nextTick(() => {
									this.$refs.hlsVideoPlayer.handelVideoUrl(datas[0]['vurl'])
								})
							} else {
								this.isVideoEmpty = true
							}
						} else {
							this.isShowVideo = false
							this.$set(this.videoForm, 'id', '')
							this.videoSelect = []
						}
					} else {
						this.isShowVideo = false
						this.$set(this.videoForm, 'id', '')
						this.videoSelect = []
					}
				})
				.catch(() => {
					this.isShowVideo = false
					this.$set(this.videoForm, 'id', '')
					this.videoSelect = []
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 视频监控下拉切换
		handleVideoChange(val) {
			let videoIndex = this.videoSelect.findIndex((item) => {
				return item.id == val
			})
			let vurl = this.videoSelect[videoIndex]['vurl']
			this.$nextTick(() => {
				this.$refs.hlsVideoPlayer.editUrl(vurl)
			})
		},
		// 获取设备操作列表
		getEquipList() {
			this.$http
				.getAction(this.$api.findOperateDeviceByOrgId, this.orgForm)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || {}
						this.equipList = datas || {}
						if (datas.sd) {
							this.equipListSd = datas.sd || []
						} else {
							this.equipListSd = []
						}
						if (datas.ssd && datas.ssd.length) {
							let ssd = datas.ssd || []
							ssd.forEach((item) => {
								item.explainStatus = item.deviceStatus
							})
							this.equipListSsd = ssd || []
						} else {
							this.equipListSsd = []
						}
					} else {
						this.equipList = {}
						this.equipListSd = []
						this.equipListSsd = []
					}
				})
				.catch(() => {
					this.equipList = {}
					this.equipListSd = []
					this.equipListSsd = []
				})
		},
		// 环境监测传感器切换-获取采集项数据
		codeChangeHandel(val) {
			let codeIndex = this.codeSelect.findIndex((item) => {
				return item.id == val
			})
			this.codeDeviceTypeId = this.codeSelect[codeIndex]['typeId']
			// 获取详情数据
			this.getEnverInfos()
			// 获取采集项下拉选
			setTimeout(() => {
				this.getItemsSelect()
			}, 500)
		},
		// 获取采集项下拉选
		async getItemsSelect() {
			let params = {
				deviceTypeId: this.codeDeviceTypeId,
			}
			await this.$http
				.getAction(this.$api.getDeviceItems, params)
				.then((res) => {
					if (res.meta.success) {
						this.isLine = true
						let datas = res.data || []
						this.itemsSelect = datas || []
						if (datas && datas.length) {
							this.$set(this.queryParam, 'listparam', datas[0]['code'])
							// 设备异常的情况，赋值默认的下拉选数据
							if (this.codeIsWarn) {
								let envItems = []
								let itemObj = {}
								datas.forEach((items) => {
									itemObj = {
										itemCode: items.code,
										itemName: items.name,
										itemUnitCode: items.itemUnitCode,
										itemValue: '--',
									}
									envItems.push(itemObj)
								})
								this.codeInfoLisst = envItems
								// 总页码赋值
								this.codeTotalPage = Math.ceil(envItems.length / 8)
								this.codePage = 1
								this.$nextTick(() => {
									this.makeInfoItems(envItems)
								})
							}
							this.$nextTick(() => {
								// 请求右下角折线图数据
								this.getLineData()
							})
						} else {
							this.isLine = false
							this.itemsSelect = []
						}
					} else {
						this.isLine = false
						this.itemsSelect = []
					}
				})
				.catch(() => {
					this.isLine = false
					this.itemsSelect = []
				})
		},
		// 获取详细的传感器数据
		async getEnverInfos() {
			let params = {
				deviceId: this.codeForm.deviceId,
			}
			await this.$http
				.getAction(this.$api.latestDeviceData, params)
				.then((res) => {
					if (res.meta.success) {
						this.codeIsWarn = false
						let datas = res.data || {}
						this.codeInfos = datas || {}
						let envItems = JSON.parse(JSON.stringify(datas.envItems)) || []
						this.codeInfoLisst = datas.envItems || []
						// 总页码赋值
						this.codeTotalPage = Math.ceil(envItems.length / 8)
						this.codePage = 1
						// 大于8开始分页
						this.makeInfoItems(envItems)
					} else {
						this.codeIsWarn = true
						this.codeInfos = {}
						this.codeInfoLisst = []
						this.codeLeftList = []
						this.codeRightList = []
						this.codeTotalPage = 1
						this.codePage = 1
					}
				})
				.catch(() => {
					this.codeIsWarn = true
					this.codeInfos = {}
					this.codeInfoLisst = []
					this.codeLeftList = []
					this.codeRightList = []
					this.codeTotalPage = 1
					this.codePage = 1
				})
		},
		makeInfoItems(envItems) {
			// 大于8开始分页
			if (envItems.length >= 8) {
				this.codeLeftList = envItems.filter((item, index) => {
					return index < 4
				})
				this.codeRightList = envItems.filter((item, index) => {
					return index >= 4 && index < 8
				})
			} else {
				if (envItems.length == 1) {
					this.codeLeftList = []
					this.codeRightList = envItems
				} else {
					let splitNum = Math.floor((envItems.length % 2) + envItems.length / 2)
					this.codeLeftList = envItems.filter((item, index) => {
						return index < splitNum
					})
					this.codeRightList = envItems.filter((item, index) => {
						return index >= splitNum && index < envItems.length
					})
				}
			}
		},
		codePageChange(type) {
			if (type == '-') {
				if (this.codePage == 1) return
				this.codePage -= 1
			} else if (type == '+') {
				if (this.codePage >= this.codeTotalPage) return
				this.codePage += 1
			}
			let envItems = this.codeInfoLisst.slice((this.codePage - 1) * 8, this.codePage * 8)
			this.makeInfoItems(envItems)
		},
		setEquip(item) {
			if (this.equipTime) {
				clearInterval(this.equipTime)
				this.equipTime = null
			}
			let setWord = ''
			if (item.deviceStatus == 'OFF') {
				setWord = '打开'
			} else {
				setWord = '关闭'
			}
			this.$confirm(`确定${setWord}此设备?`, '操作', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					let deviceActions = item.deviceActions

					// 需要操作的对象
					let arrs = []
					// 操作的id
					let actionId = ''
					// 判断当前状态是打开还是关闭
					// 关闭状态，请求打开操作
					if (item.deviceStatus == 'OFF') {
						arrs = deviceActions.filter((item) => {
							return item.code == 'ON'
						})
					} else {
						arrs = deviceActions.filter((item) => {
							return item.code == 'OFF'
						})
					}
					actionId = arrs[0]['id']
					let params = {
						orgId: this.equipList.orgId,
						deviceId: item.deviceId,
						actionId: actionId,
					}
					this.$nextTick(() => {
						this.makeSetRequest(params)
					})
				})
				.catch(() => {
					this.equipTime = setInterval(() => {
						// 获取设备操作列表
						this.getEquipList()
					}, 1000)
				})
		},
		// 形成设备操作
		setEquiptwo(item, type, index) {
			/**
			 * 判断设备的状态，
			 * 如果是停止中，不能进行操作
			 * 如果是停止，可进行三个操作
			 * 如果是上升中，可暂停和下降
			 * 如果是下降，可暂停和上升
			 * */
			// 如今的状态
			let nowCode = item.explainStatus
			// 可操作的状态列表
			let deviceActions = item.deviceActions
			// 需要操作的对象
			let arrs = []
			// 操作的id
			let actionId = ''
			// 如果是进行中，不能操作
			if (nowCode.indexOf('LOADING') > -1) {
				return
			}
			// 操作和现在进行的状态相同，则不进行操作
			if (nowCode == 'DOWN') {
				if (type == 'DOWN') return
			} else if (nowCode == 'UP') {
				if (type == 'UP') return
			} else if (nowCode == 'STOP') {
				if (type == 'STOP') return
			}

			arrs = deviceActions.filter((item) => {
				return item.code == type
			})
			// 可操作状态下清除定时器
			if (this.equipTime) {
				clearInterval(this.equipTime)
				this.equipTime = null
			}
			this.$confirm(`确定${arrs[0]['name']}此设备?`, '操作', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					// 操作的id
					actionId = arrs[0]['id']
					let params = {
						orgId: this.equipList.orgId,
						deviceId: item.deviceId,
						actionId: actionId,
					}
					// this.$nextTick(() => {
					// 	this.$set(this.equipListSsd[index], 'explainStatus', type + 'LOADING')
					// })
					this.$nextTick(() => {
						this.makeSetRequest(params, index, type)
					})
				})
				.catch(() => {
					this.equipTime = setInterval(() => {
						// 获取设备操作列表
						this.getEquipList()
					}, 1000)
				})
		},
		makeSetRequest(params, index, type) {
			this.$http
				.postAction(this.$api.operateDeviceAction, params)
				.then((res) => {
					if (res.meta.success) {
						this.$nextTick(() => {
							this.$set(this.equipListSsd[index], 'explainStatus', type + 'LOADING')
						})
						this.$message('设备操作成功!', 'success')
						// 重新请求数据
						setTimeout(() => {
							// 获取设备操作列表

							// 获取设备操作列表
							this.getEquipList()

							this.equipTime = setInterval(() => {
								// 获取设备操作列表
								this.getEquipList()
							}, 1000)
						}, 200)
					} else {
						this.$message(res.meta.message, 'error')
						this.equipTime = setInterval(() => {
							// 获取设备操作列表
							this.getEquipList()
						}, 1000)
					}
				})
				.catch(() => {
					this.$message('服务出错，请稍后重试', 'error')
				})
		},
		// tab切换-设备类型切换
		changeTab(ind) {
			if (this.tabIndex == ind) return
			this.tabIndex = ind
			$('.lb-mains').animate({ scrollTop: 0 }, 0)
		},
		// 查询按钮点击
		searchClick() {
			let miao = this.queryParam.startTime.split(' ')[1] || '00:00:00'
			let preMonthDay = new Date(GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) + ' ' + miao) //6个月之后的日期
			let startTimeCuo = new Date(this.queryParam.endTime).getTime()
			if (startTimeCuo >= preMonthDay.getTime()) {
				this.$message('选择时间跨度范围不允许超过6个月', 'warning')
				return false
			}
			this.getLineData()
		},
		// 请求右下角折线图数据
		getLineData() {
			this.queryParam.list = this.queryParam.listparam.split()
			// 对象合并
			let params = Object.assign({}, this.queryParam, this.orgForm)
			let codeIndex = this.codeSelect.findIndex((item) => {
				return item.id == this.codeForm.deviceId
			})
			this.$set(params, 'sensorCode', this.codeSelect[codeIndex]['serialNumber'])
			this.$delete(params, 'listparam')
			let xAxis = []
			let yAxis = []
			let yName = ''
			let yUnit = ''
			this.$http
				.postAction(this.url.lineChart, params)
				.then((res) => {
					if (res.meta.success) {
						let datas = res.data || {}
						Object.keys(datas).forEach((key) => {
							let dataIndex = datas[key].findIndex((itemt) => {
								return itemt.sensorCode == params.sensorCode
							})
							if (dataIndex > -1) {
								xAxis.push(key)
								yAxis.push(datas[key][dataIndex]['acquisitionData'])
							}
						})
						if (xAxis.length) {
							yName = datas[xAxis[0]][0]['acquisitionItemName']
							console.log(xAxis[0])
							yUnit = datas[xAxis[0]][0]['acquisitionItemUnitCode']

							this.isLine = true
							this.$nextTick(() => {
								this.lineChart(xAxis, yAxis, yName, yUnit)
							})
						} else {
							this.isLine = false
						}
					} else {
						this.isLine = false
					}
				})
				.catch(() => {
					this.isLine = false
				})
		},
		// 折线图绘制
		lineChart(xData, yData, yName, yUnit) {
			const _this = this
			let myChart = this.$echarts.init(this.$refs.chartLine)
			let maxY = Math.max(...yData)
			let symbolSize = 60
			let symbolFont = 12
			if (maxY.length <= 2) {
				symbolSize = 40
				symbolFont = 16
			} else if (maxY.length > 2 && maxY.length <= 3) {
				symbolSize = 50
				symbolFont = 14
			} else if (maxY.length > 3 && maxY.length < 4) {
				symbolSize = 60
				symbolFont = 12
			} else {
				symbolSize = 65
				symbolFont = 12
			}
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [14, 17],
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#DADADA',
							type: 'solid',
							width: 2,
						},
					},
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						infos += `<div style="text-align:left;">${yName}：<span style="color:#2DAEA9">${param[0].value}${yUnit}</span></div><div style="margin-top:12px">${param[0].name}</div`
						return infos
					},
				},
				color: '#2DAEA9',
				grid: {
					left: '8%',
					bottom: '13%',
					top: '16%',
					right: '8%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					name: '（' + yUnit + '）',
					nameTextStyle: {
						color: '#6B6B6B',
						fontSize: 14,
						align: 'right',
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
				},
				series: [
					{
						type: 'line',
						smooth: true,
						showSymbol: false,
						symbolSize: 10,
						itemStyle: {
							borderColor: '#2DAEA9',
							borderWidth: 8,
						},
						areaStyle: {
							color: 'rgba(45, 174, 169, 0.26)',
						},
						lineStyle: {
							width: 4,
						},
						markPoint: {
							symbolSize: symbolSize,
							label: {
								color: '#fff',
								fontSize: symbolFont,
							},
							data: [
								{
									type: 'max',
									name: '最大值',
									itemStyle: {
										color: '#FF648C',
									},
								},
								{
									type: 'min',
									name: '最小值',
									itemStyle: {
										color: '#3EA2EF',
									},
								},
							],
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值',
									lineStyle: {
										type: 'solid',
										color: '#FFA800',
									},
									label: {
										position: 'middle',
										formatter: '平均值:{c}',
										color: '#FFA800',
										distance: 10,
										fontSize: 16,
									},
									symbol: 'none',
								},
							],
						},
						data: yData,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// 设备操作的图片
		equipImg({ explainStatus }, types) {
			let imgs = ''
			// 如果是停止按钮
			if (types == 'STOP') {
				switch (explainStatus) {
					case 'STOP':
						imgs = require('@/assets/image/production/close_h.png')
						break
					case 'STOPLOADING':
						imgs = require('@/assets/image/production/close_load.png')
						break

					default:
						imgs = require('@/assets/image/production/close_hui.png')
						break
				}
			} else if (types == 'DOWN') {
				switch (explainStatus) {
					case 'DOWN':
						imgs = require('@/assets/image/production/down_h.png')
						break
					case 'DOWNLOADING':
						imgs = require('@/assets/image/production/down_load.png')
						break

					default:
						imgs = require('@/assets/image/production/down_hui.png')
						break
				}
			} else if (types == 'UP') {
				switch (explainStatus) {
					case 'UP':
						imgs = require('@/assets/image/production/up_h.png')
						break
					case 'UPLOADING':
						imgs = require('@/assets/image/production/up_load.png')
						break

					default:
						imgs = require('@/assets/image/production/up_hui.png')
						break
				}
			}
			return imgs
		},
		// 形成设备上面的名称
		equipWord({ explainStatus, ssdDeviceStatus }) {
			let words = ''
			switch (explainStatus) {
				case 'STOP':
					words = '已停止'
					break
				case 'DOWN':
					words = `已下降${ssdDeviceStatus}%`
					break
				case 'UP':
					words = `已上升${ssdDeviceStatus}%`
					break
				case 'STOPLOADING':
					words = '停止响应中'
					break
				case 'DOWNLOADING':
					words = '下降响应中'
					break
				case 'UPLOADING':
					words = '上升响应中'
					break

				default:
					break
			}
			return words
		},
	},
}
